import { render, staticRenderFns } from "./AllChannelSliderBar.vue?vue&type=template&id=6c10dfbe&scoped=true"
import script from "./AllChannelSliderBar.vue?vue&type=script&lang=js"
export * from "./AllChannelSliderBar.vue?vue&type=script&lang=js"
import style0 from "./AllChannelSliderBar.vue?vue&type=style&index=0&id=6c10dfbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c10dfbe",
  null
  
)

export default component.exports